/**
 * Takes an image hosted on rack cdn (commercetools) and changes the file size
 * @param imageUrl
 * @param size on of "thumb" | "small" | "medium" | "large" | "zoom"
 * -thumb (50x50)
 * -small (150x150)
 * -medium (400x400)
 * -large (700x700)
 * -zoom (1400x1400)
 */
const changeImageSize = (
	imageUrl: string,
	size: "thumb" | "small" | "medium" | "large" | "zoom",
) => {
	const urlParts = imageUrl.split(".")
	// get the fileType (e.g. jpg) and add the size
	const fileType = urlParts[urlParts.length - 1]
	return imageUrl.replace(`.${fileType}`, `-${size}.${fileType}`)
}

export default changeImageSize
